import { render, staticRenderFns } from "./RecentCalls.vue?vue&type=template&id=60b27063&scoped=true&"
import script from "./RecentCalls.vue?vue&type=script&lang=js&"
export * from "./RecentCalls.vue?vue&type=script&lang=js&"
import style0 from "./RecentCalls.vue?vue&type=style&index=0&id=60b27063&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b27063",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VBtn,VContainer,VDataTable,VIcon,VProgressLinear})
